import { ErrorMessage } from '@hookform/error-message';
import i18next from 'i18next';
import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { MdClose, MdHistory } from 'react-icons/md';
import { useControlHistorys, useCreateHistoryControl } from '../api/hooks/useRiskThemes';
import { useDesignSystem } from '../context/designSystemContext';
import { ControlType } from '../types/controlsRisk';
import { HistoryControlType } from '../types/historyControl';
import { HistoryItem } from './historyItem';

export const ViewHistory = ({ control, canEditRisk, refetchRiskTheme }: { control: ControlType, canEditRisk: boolean, refetchRiskTheme: () => void }) => {
    const [viewHistoryControl, setViewHistoryControl] = useState<boolean>(false);
    const [addingHistory, setAddingHistory] = useState<boolean>(false);
    const [isSubmitting, setIsSubmitting] = useState<boolean>(false); // control submitting

    const { register, handleSubmit, reset, formState: { errors } } = useForm<HistoryControlType>();

    const { designSystem } = useDesignSystem();

    // Função para impedir a propagação do clique
    const stopPropagation = (e: React.MouseEvent) => {
        e.stopPropagation();
    };

    const clickModal = () => {
        setViewHistoryControl(!viewHistoryControl);
        setAddingHistory(false); // Reset adding history state when closing modal
    };

    const startAddingHistory = () => {
        setAddingHistory(true);
    };

    const cancelAddingHistory = () => {
        setAddingHistory(false);
        reset();
    };

    const { mutate: createHistoryControl } = useCreateHistoryControl();

    const onSubmit = (data: HistoryControlType) => {
        setIsSubmitting(true); // Make sure you don't click twice
        // Logic to create history
        createHistoryControl({ id: control.id, control: data },
            {
                onSuccess: () => {
                    refetchHistoryItems();
                    refetchRiskTheme();
                    setAddingHistory(false);
                    reset();
                },
                onError: (error) => {
                    console.error('Erro ao criar histórico:', error);
                }
            }
        );
        setIsSubmitting(false);
        //setAddingHistory(false);
    };


    const { error, data, refetch: refetchHistoryItems } = useControlHistorys(control.id, viewHistoryControl);
    // if (isLoading) return <>Carregando...<button className='h-[1.5rem] fixed right-[55px]' onClick={clickModal}><MdHistory className='w-4 h-4' /></button> </>;
    if (error) return <p>Erro pressione F5<button className='h-[1.5rem] fixed right-[55px]' onClick={clickModal}><MdHistory className='w-4 h-4' /></button></p>;

    return (
        <>
            <button className='h-[1.5rem] w-[5%] flex flex-row justify-center items-center' onClick={clickModal}><MdHistory className='w-4 h-4 align-middle' /></button>

            {viewHistoryControl ?
                <div className="fixed inset-0 bg-black bg-opacity-15 z-50 grid justify-items-end" onClick={() => { clickModal(); }}>
                    <div className="fixed top-1/2 right-1/2 bg-white border rounded-xl h-[400px] w-[650px] -translate-y-1/2 translate-x-1/2 z-60 pl-5 pr-2 py-4 " onClick={stopPropagation}>

                        <div className='absolute top-2 right-2'>
                            <MdClose
                                className='cursor-pointer text-red-500'
                                size={24}
                                onClick={clickModal}
                            />
                        </div>

                        <div className="font-openSans font-bold text-sextenary text-[16px] leading-[16px] tracking-[0.18px] ">
                            {i18next.t('control_editor')}
                        </div>

                        <div className='flex flex-col h-full p-3'>
                            {addingHistory ? (
                                <form onSubmit={handleSubmit(onSubmit)}>
                                    <div className='mb-4'>
                                        <label className='font-openSans font-bold text-[13px] leading-[15px] tracking-[0.19px]'>{i18next.t("history_date")}:</label>
                                        <input type="date" className='border rounded p-2 w-full' {...register('date', { required: i18next.t('required_field') })} />
                                        <ErrorMessage errors={errors} name="date" render={({ message }) => <p>{message}</p>} />
                                    </div>

                                    <div className='mb-4'>
                                        <label className='font-openSans font-bold text-[13px] leading-[15px] tracking-[0.19px]'>{i18next.t("history_progress")}:</label>
                                        <textarea className='border rounded p-2 w-full' {...register('description', { required: i18next.t('required_field') })} />
                                        <ErrorMessage errors={errors} name="description" render={({ message }) => <p>{message}</p>} />
                                    </div>

                                    <div className='flex justify-end space-x-2 fixed bottom-4 right-4'>
                                        <button type="button" 
                                            className='font-openSans bg-white text-sextenary p-2 border border-[1px] border-sextenary rounded-lg text-[14px] leading-[13.5px] tracking-[0.19px]' 
                                            onClick={cancelAddingHistory}>
                                                {i18next.t("button_cancel")}
                                        </button>
                                        {!isSubmitting && 
                                            (<button type="submit" 
                                                className='font-openSans text-white p-2 rounded-lg text-[14px] leading-[13.5px] tracking-[0.19px]'
                                                style={{
                                                    backgroundColor: designSystem?.cssBasics.primaryColor,
                                                }}
                                            >
                                                    {i18next.t("button_create")}
                                            </button>)}
                                    </div>
                                </form>
                            ) : (
                                <>
                                    <div className='overflow-y-auto mb-9'>
                                        {data?.map((history: HistoryControlType) => (
                                            <HistoryItem key={history.id} history={history} canEditRisk={canEditRisk} refetchHistoryItems={refetchHistoryItems} refetchRiskTheme={refetchRiskTheme} />
                                        ))}
                                    </div>
                                    {canEditRisk && <button className='font-openSans text-white p-2 rounded-lg text-[14px] leading-[15px] tracking-[0.19px] fixed bottom-4 right-4' onClick={startAddingHistory} style={{
                                        backgroundColor: designSystem?.cssBasics.primaryColor,
                                    }}>{i18next.t('button_add_history')}</button>}
                                </>
                            )}
                        </div>
                    </div>
                </div>
                :
                null}
        </>
    )
}